import useScreenSize from 'hooks/useScreenSize';
import PhotoGalleryActions from './PhotoGalleryActions';
import PhotoGallerySwitch from './PhotoGallerySwitch';
import styles from './styles/PhotoGalleryControls.module.scss';

export default function PhotoGalleryControls() {
  const { isSmallScreen } = useScreenSize();

  return (
    <div className={styles.ActionsContainer}>
      <div>{!isSmallScreen && <PhotoGallerySwitch />}</div>
      <div>
        <PhotoGalleryActions buttonType="BlackOnWhite" iconColor="#000000" />
      </div>
    </div>
  );
}
